import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';
import theme from 'src/theme';

const ResultAvalView = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '16px',
        paddingTop: { xs: '24px', sm: '40px' },
        paddingBottom: { xs: '16px', sm: '24px' }
      }}
    >
      <Box
        sx={{
          width: 96,
          height: 96,
          borderRadius: '50%',
          backgroundColor: 'rgba(21, 55, 80, 0.08)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 64, color: theme.palette.primary.main }} />
      </Box>
      <Typography
        variant="h2"
        color="primary"
        sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}
      >
        {t('AVAL_BURO_FORM.RESULT.TITLE')}
      </Typography>
      <Typography variant="body1" sx={{ color: theme.palette.text.secondary, maxWidth: 400, lineHeight: 1.7 }}>
        {t('AVAL_BURO_FORM.RESULT.DESCRIPTION')}
      </Typography>
    </Box>
  );
};

export default ResultAvalView;
